import { AppSettings } from '@/config/app-settings';
import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import axios from 'axios';
import { Department } from '@/models/department.interface';

@Module
export default class DepartmentStore extends VuexModule {
  /* tslint:disable */
  private _departments: Array<Department> = new Array();
  private _isFetched: boolean = false;
  /* tslint:enable */

  @Mutation public setDepartmentsMut(deps: Department[]) {
    this._departments = deps;
    this._isFetched = true;
  }

  @Action({ commit: 'setDepartmentsMut' }) public async getDepartmentsAction(): Promise<Department[]> {
    try {
      const response = await axios.get(`${process.env.VUE_APP_API_URL}/department`);
      return response.data;
    } catch (err) {
      return [];
    }
  }

  get departments(): Department[] {
    return this._departments;
  }

  get isDepartmentsFetched(): boolean {
    return this._isFetched;
  }
}
